import React, { useEffect, useState } from "react";
import "./style.css";
import AdminBoardingItem from "../AdminBookingPage/AdminBoardingItem";
import steering from "../../../assets/steering.svg";
import { convertToGMT, getSeatCategory } from "../../../utils/Functions";
import CabScreenIcon from '../../../assets/screennew.png'
import { postSaveMTripCategory } from "../../../utils/api.functions";
import { useParams } from "react-router-dom";

const AdminSeatBooking = ({ busSelect, fetchCategories, handleApiRedirect, tripDetail }) => {
  const params = useParams()
  const apikey = sessionStorage.getItem("key");
  // Initialize selection state (false means not selected)
  const [selectedSeats, setSelectedSeats] = useState(
    busSelect?.seats?.reduce((acc, seat) => {
      acc[seat.id] = false; // Default all seats as unselected
      acc[`${seat.id}_type`] = seat.type || "";// Default all seats as unselected
      acc[`${seat.id}_name`] = "";// Default all seats as unselected
      acc[`${seat.id}_age`] = "18";// Default all seats as unselected
      acc[`${seat.id}_gender`] = "";// Default all seats as unselected
      return acc;
    }, {})
  );
    const [selectedCount, setSelectedCount] = useState(0);
  const [mTripID, setMtripID] = useState("");


      // ✅ Select one seat by default
      useEffect(() => {
        const allSeats = busSelect?.seats?.filter(seat => seat.available) || [];
      
        if (allSeats.length > 0 && selectedCount === 0 && !params?.id) {
          const firstSeat = allSeats[0];
          setSelectedSeats({
            [firstSeat.id]: true,
            [`${firstSeat.id}_type`]: firstSeat.type || "normal"
          });
          setSelectedCount(1);
        }
      }, [busSelect]);
    
      // ✅ Increment seat selection
    const incrementSeat = () => {
      const allSeats = busSelect?.seats?.filter(seat => seat.available) || [];
    
      if (selectedCount >= allSeats.length) return;
    
      const nextSeat = allSeats.find(seat => !selectedSeats[seat.id]);
      if (nextSeat) {
        setSelectedSeats(prev => ({
          ...prev,
          [nextSeat.id]: true,
          [`${nextSeat.id}_type`]: nextSeat.type || "normal"
        }));
        setSelectedCount(prev => prev + 1);
      }
    };
    
    // ✅ Decrement seat selection
    const decrementSeat = () => {
      if (selectedCount <= 1) return;
    
      const selectedIds = Object.keys(selectedSeats).filter(key => !key.includes("_type"));
      
      // Remove the last selected seat
      const lastSelectedSeatId = selectedIds[selectedIds.length - 1];
    
      if (lastSelectedSeatId) {
        const updatedSeats = { ...selectedSeats };
        delete updatedSeats[lastSelectedSeatId];
        delete updatedSeats[`${lastSelectedSeatId}_type`];
        setSelectedSeats(updatedSeats);
        setSelectedCount(prev => prev - 1);
      }
    };

  useEffect(() => {
    if (params?.id && tripDetail?.customer_details?.customer) {
      // Assuming each customer has a unique seatId and seatType
      const customerData = tripDetail.customer_details.customer;

      // Loop through each customer to update the seat selections
      customerData.forEach((customer) => {
        const { id, seat_type, seat_id, name, age, gender } = customer;

        setSelectedSeats((prevState) => ({
          ...prevState,
          [id]: true, // Set the seat as selected
          [`${id}_type`]: handleSeatName(groupSeatsInPairs(busSelect?.seats, busSelect?.seats_row, busSelect?.seats_col_json), [], 1, busSelect?.cat_max_size, seat_id), // Set the seat type
          [`${id}_name`]: name ? name : "",
          [`${id}_gender`]: gender ? gender : "",
          [`${id}_age`]: age ? age : "18",
        }));
      });
    }
  }, [tripDetail, params?.id]);

  useEffect(() => {
    if(params?.id && tripDetail){
      setSelectedCount(tripDetail?.seats)
    }
  },[tripDetail, params?.id])

  // Handle seat selection/deselection
  const handleSeatChange = (seatId, seatType) => {
    fetchCategories()
    setSelectedSeats((prevState) => ({
      ...prevState,
      [seatId]: !prevState[seatId], // Toggle the selection state of the clicked seat
      [`${seatId}_type`]: !prevState[seatId] === false ? "" : seatType
    }));
  };


  const groupSeatsInPairs = (seatData, row, column) => {
    const groupedSeats = [];
    let seatRow = row || 2;
    let seatColumn = Array.isArray(column) ? {
      1: 2,
      2: 3
    } : column;
    // console.log({seatRow,seatColumn})
    for (let i = 1; i <= seatRow; i++) {
      // Slice the next 'rowSize' seats for the current group
      groupedSeats.push(seatData.slice(0, seatColumn[i]));
      seatData = seatData.slice(seatColumn[i]);  // Remove those seats from the original array
    }

    // console.log({ groupedSeats })
    return { data: groupedSeats, length: groupedSeats.length };
  };

  const showBookingBoardingItemIfSelected = (seatData, selectedSeats, fetchCategories, handleApiRedirect, tripDetail) => {
    // Create the selectedValue array by mapping over seatData and adding selected status
    const selectedValue = seatData.map((seat) => ({
      ...seat,
      selected: selectedSeats[seat.id] || false, // Use false if the seat is not selected
      seat_type: selectedSeats[`${seat.id}_type`] || "normal", // Use false if the seat is not selected
      name: selectedSeats[`${seat.id}_name`] || "",
      gender: selectedSeats[`${seat.id}_gender`] || "",
      age: selectedSeats[`${seat.id}_age`] || "18",
    }));

    // Check if any seat is selected
    const anySeatSelected = selectedValue.some((seat) => seat.selected);

    // Conditionally render the AdminBoardingItem component if any seat is selected
    if (anySeatSelected) {
      return (
        <AdminBoardingItem
          busSelect={busSelect}
          selectedValue={selectedValue}
          fetchCategories={fetchCategories}
          handleApiRedirect={handleApiRedirect}
          tripDetail={tripDetail}
        />
      );
    }

    // Return null if no seat is selected (you can modify this to return a message or empty UI)
    return null;
  };

  const seatViewClassName = (size) => {
    // return [4, 6, 8, 10].includes(size) ? "" : "seat_rotate_container_big"
    return "seat_rotate_container_big"
  }

  const handleSeatName = (groupDetail, length, i, maxSize, seat) => {
    const groupData = { ...groupDetail }; // Make a shallow copy of the groupDetail object to avoid direct mutation
    groupData.data[0] = [{
      "id": "c0",
      "seat_id": 0,
      "available": false,
      "normal": 400,
      "window": 500
    }, ...groupDetail?.data[0]]; // Spread the original data into the new array
    // console.log("seat",groupData, `seatCheck`,groupDetail,groupDetail?.data?.length)
    const valueLength = getSeatCategory(maxSize, groupData)
    return valueLength.includes(seat) ? 'window' : 'normal'
    // return valueLength.includes(seat) ? 'normal' : 'window'

  }

  useEffect(() => {
    getCategoryMTrip()
  }, [])

  const getCategoryMTrip = async () => {
    try {
      const response = await postSaveMTripCategory({
        category_id: busSelect?.category_id,
        category_time: convertToGMT(new Date(busSelect?.departure))
      }, apikey);
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        setMtripID(value)
      }
    } catch (error) {
      console.log("Create MTrip Error::", error);
    }
  };

  return (
    <div className={`st_seatlayout_main_wrapper seat_booking_main_content ${showBookingBoardingItemIfSelected(busSelect?.seats, selectedSeats, fetchCategories, handleApiRedirect, tripDetail) ? "seat_booking_main_content_show" : ""}`}>
      {/* <div className="container_seat_layout flex_item">
        <div className="st_seat_lay_heading">
          <h3>Click on an Available seat to proceed.</h3>
        </div>
        <div className="seat_show_content">
          <div className="seat_show_content_avail">
            <span></span> Available
          </div>
          <div className="seat_show_content_deavail">
            <span></span> Unavailable
          </div>
        </div>
        <div className="seat_main_div_container_layout">
          <div className="seat_main_div_container_layout_image flex_item_seat flex_item_seat_image">
            <img
              src={CabScreenIcon}
              alt={busSelect?.name}
            />
          </div>

          <div data-seat-row={busSelect?.seats_row} className="st_seat_lay_row st_seat_lay_row_main flex_item_seat flex_item_seat_main">
            {groupSeatsInPairs(busSelect?.seats, busSelect?.seats_row, busSelect?.seats_col_json).data.map((group, index) => (
              <ul key={new Date().getTime() + index} className={`seat_rotate_container ${seatViewClassName(busSelect?.seats?.length)}`}>

                {index == 0 && <li className="seat_disable">
                  <input type="checkbox" id="c0" name="cb" />
                  <label className="seat_rotate" htmlFor="c0">
                    <img src={steering} alt="" />
                  </label>
                </li>}
                {group.map((seat, i) => {
                  const seatType = handleSeatName(groupSeatsInPairs(busSelect?.seats, busSelect?.seats_row, busSelect?.seats_col_json), group.length, i, busSelect?.cat_max_size, seat.seat_id)
                  return (
                    <li
                      key={seat.id}
                      className={`${selectedSeats[seat.id] ? "seat_selected" : "seat_empty"
                        } ${seat.available ? "" : "seat_disable"} ${params?.id && selectedSeats[seat.id] ? "seat_disable_view" : ""}` }
                    >
                      {seat?.available && <span>Pay Rs.{seat[seatType]}</span>}
                      <input
                        type="checkbox"
                        id={seat.id}
                        disabled={seat.available !== true}
                        checked={selectedSeats[seat.id]} // Disable checkboxes for the first two rows
                        onChange={() => handleSeatChange(seat.id, seatType)} // Toggle selection for common seats
                      />
                      <label className="seat_rotate" htmlFor={seat.id}>
                        {selectedSeats[seat.id] && <b>{seat?.id}</b>}
                        {!selectedSeats[seat.id] && seat?.available && <strong>&#8377;{seat[seatType]}</strong>}
                        
                      </label>
                    </li>
                  );
                })}
              </ul>
            ))}
          </div>
        </div>
      </div> */}
      <div className="container_seat_layout flex_item">
        <div className="st_seat_lay_heading">
          <h3>Select seat to proceed.</h3>
        </div>
        <div className="seat_main_div_container_layout">
          <div className="seat_selector_container">
            <button type="button" onClick={() => { decrementSeat() }} disabled={selectedCount <= 1 || params?.id}><i className="fas fa-minus"></i></button>
            <span>{selectedCount}</span>
            <button type="button" onClick={() => { incrementSeat() }} disabled={selectedCount == busSelect?.seats?.length || params?.id}><i className="fas fa-plus"></i></button>
          </div>
        </div>
      </div>
      <div className="flex_item">
        {showBookingBoardingItemIfSelected(busSelect?.seats, selectedSeats, fetchCategories, handleApiRedirect, tripDetail)}
      </div>
    </div>
  );
};

export default AdminSeatBooking;
